// extracted by mini-css-extract-plugin
export default {"cls1":"VeloChip-StyledChipSet_cls1__OxDEv","cls2":"VeloChip-StyledChipSet_cls2__S5WQW VeloChip-StyledChipSet_cls1__OxDEv","slimline":"VeloChip-StyledChipSet_slimline__7QlME"};